import { Link, useNavigate } from 'react-router-dom';
import { Button, Checkbox, Input } from 'common/components';
import { Controller, useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

import styles from './DemoRequest.module.scss';

const PHONE_MIN_DIGITS = 10;

export const DemoRequest = () => {
    const {
        register,
        handleSubmit,
        control,
        reset,
        formState: { errors },
    } = useForm();
    const navigate = useNavigate();

    const onSubmit = (data: any) => {
        toast.success('Demo request submitted successfully.', {
            autoClose: 4000,
        });
        reset();

        navigate('/login');
    };

    return (
        <div className={styles.demoRequestPageContainer}>
            <div className={styles.demoRequestBox}>
                <div className='flex justify-between items-center'>
                    <img src='/SLAILOGO.png' alt='SLAI Logo' className={styles.slaiLogo} />
                    <h2 className='font-bold'>Request a Demo</h2>
                </div>
                <p className='text-secondary mt-2xl mb-2xl'>
                    Fill out the form below and we'll get back to you shortly.
                </p>
                <form onSubmit={handleSubmit(onSubmit)} className='flex flex-col gap-lg'>
                    <Input label='Full Name' {...register('name', { required: 'Full name is required' })} />
                    <Input
                        label='Phone Number'
                        placeholder='e.g. +1 (555) 123-4567'
                        type='tel'
                        error={!!errors.phone}
                        errorText={errors.phone?.message as string | undefined}
                        {...register('phone', {
                            required: 'Phone number is required',
                            validate: (value) => {
                                const digits = (value || '').replace(/\D/g, '');
                                return (
                                    digits.length >= PHONE_MIN_DIGITS ||
                                    `Enter a valid phone number (at least ${PHONE_MIN_DIGITS} digits)`
                                );
                            },
                        })}
                    />
                    <Input label='Company Name' {...register('company')} />

                    <Controller
                        control={control}
                        name='consent'
                        rules={{ required: 'Consent is required' }}
                        render={({ field }) => (
                            <Checkbox
                                label="I agree that SLAI might contact me at the phone number I provide, regarding SLAI's services. Msg and data rates may apply. Message frequency varies. Reply STOP to OPT out and help for assistance."
                                checked={field.value}
                                onChange={field.onChange}
                                onBlur={field.onBlur}
                                error={!!errors.consent}
                                errorText={errors.consent?.message as string | undefined}
                            />
                        )}
                    />
                    <p className='text-secondary'>
                        By submitting this form, you agree to our{' '}
                        <Link className={styles.linkText} to='/terms?demo-request=true'>
                            Terms and Conditions
                        </Link>{' '}
                        and{' '}
                        <Link className={styles.linkText} to='/privacy?demo-request=true'>
                            Privacy Policy
                        </Link>
                        .
                    </p>

                    <div className='flex flex-col gap-lg mt-xl'>
                        <Button type='submit' variant='primary'>
                            Submit Request
                        </Button>
                        <Button type='button' variant='ghost' onClick={() => navigate('/login')}>
                            Back to Login
                        </Button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default DemoRequest;
